var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose, Type } from 'class-transformer';
import { IsDateString, IsNumber, IsObject, IsOptional, IsString, IsUUID } from 'class-validator';
import { InvoiceFullSizeDto } from './invoice.full-size.dto.js';
export class InvoiceLineFullSizeDto {
    id;
    createdAt;
    updatedAt;
    stripeId;
    description;
    amount;
    unitAmount;
    quantity;
    invoice;
    invoiceId;
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], InvoiceLineFullSizeDto.prototype, "id", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], InvoiceLineFullSizeDto.prototype, "createdAt", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], InvoiceLineFullSizeDto.prototype, "updatedAt", void 0);
__decorate([
    IsString(),
    Exclude(),
    __metadata("design:type", String)
], InvoiceLineFullSizeDto.prototype, "stripeId", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], InvoiceLineFullSizeDto.prototype, "description", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], InvoiceLineFullSizeDto.prototype, "amount", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], InvoiceLineFullSizeDto.prototype, "unitAmount", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], InvoiceLineFullSizeDto.prototype, "quantity", void 0);
__decorate([
    IsObject(),
    Expose(),
    Type(() => InvoiceFullSizeDto),
    __metadata("design:type", InvoiceFullSizeDto)
], InvoiceLineFullSizeDto.prototype, "invoice", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], InvoiceLineFullSizeDto.prototype, "invoiceId", void 0);
//# sourceMappingURL=invoice-line.full-size.dto.js.map